import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { FileItem } from './FileItem'
import { useGetColumns } from 'components/utility/sandbox_upload/hooks'

function extractStatuses(files, errors) {
  let uploaded = 0,
    requiresAttention = 0,
    failed = 0

  Object.keys(files).forEach((key) => {
    const file = files[key]
    const error = errors[key]

    if (file.stage === 'completed') uploaded++
    if (file.stage === 'failed') {
      if (error?.code === 'PASSWORD_REQUIRED') {
        requiresAttention++
      } else {
        failed++
      }
    }
  })

  return { uploaded, requiresAttention, failed }
}

const Header = ({ uploaded = 0, requiresAttention = 0, failed = 0 }) => {
  return (
    <div className="dome-d-flex dome-justify-between">
      <div>
        <span className="dome-p3 dome-color-med-grey">{uploaded > 0 && `${uploaded} uploaded`}</span>
      </div>
      <div className="dome-d-flex dome-gap6">
        <span className="dome-p3 dome-color-aqua">
          {requiresAttention > 0 && `${requiresAttention} attention required`}
        </span>
        <span className="dome-p3 dome-color-red-alert">{failed > 0 && `${failed} failed`}</span>
      </div>
    </div>
  )
}

export function FileList({ files = {}, errors = {} }) {
  const [column, ref] = useGetColumns(500, Object.keys(files).length === 1)

  const { uploaded, requiresAttention, failed } = extractStatuses(files, errors)

  return (
    <div className="dome-d-flex dome-gap6 dome-flex-column">
      {(uploaded > 0 || requiresAttention > 0 || failed > 0) && (
        <Header uploaded={uploaded} requiresAttention={requiresAttention} failed={failed} />
      )}
      <div ref={ref} aria-colspan={column} className="dome-file-uploader-list-item">
        {Object.keys(files).map((id) => (
          <FileItem key={id} id={id} file={files[id]} error={errors[id]} />
        ))}
      </div>
    </div>
  )
}

FileList.propTypes = {
  files: PropTypes.shape({
    [PropTypes.string]: PropTypes.any,
  }),
}
